import { useEffect, useRef } from "react";

export const useInterval = (cb, delay) => {
  const savedCallback = useRef();

  useEffect(() => {
    savedCallback.current = cb;
  }, [cb]);

  useEffect(() => {
    if (delay !== null) {
      const intervalId = setInterval(() => savedCallback.current(), delay);
      return () => clearInterval(intervalId);
    }
  }, [delay]);
};
